import { useEffect } from 'react';

import * as Sentry from '@sentry/react';
import { AlertTriangle, Home, RefreshCw } from 'lucide-react';
import { useRouteError } from 'react-router';

import { Button } from './ui/button';

const RouteErrorBoundary = () => {
  const error = useRouteError();

  useEffect(() => {
    if (error === undefined || error === null) return;
    Sentry.withScope((scope) => {
      scope.setTag('errorBoundary', 'route');
      Sentry.captureException(error);
    });
  }, [error]);

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-blue-50/30 p-4">
      <div className="max-w-lg w-full">
        {/* Error Card */}
        <div className="relative overflow-hidden rounded-2xl border border-slate-200/60 bg-white shadow-xl shadow-slate-900/10">
          {/* Top gradient bar */}
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-500 via-orange-500 to-red-600" />

          <div className="p-8">
            {/* Icon */}
            <div className="flex justify-center mb-6">
              <div className="relative">
                <div className="absolute inset-0 bg-red-100 rounded-full animate-ping opacity-20" />
                <div className="relative flex items-center justify-center w-20 h-20 bg-gradient-to-br from-red-50 to-orange-50 rounded-full border-2 border-red-100">
                  <AlertTriangle className="w-10 h-10 text-red-500" strokeWidth={1.5} />
                </div>
              </div>
            </div>

            {/* Title */}
            <h1 className="text-2xl font-bold text-center text-slate-800 mb-2">
              문제가 발생했습니다
            </h1>

            {/* Description */}
            <p className="text-center text-slate-500 mb-6">
              예상치 못한 오류가 발생했습니다.
              <br />
              잠시 후 다시 시도해 주세요.
            </p>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-3">
              <Button
                onClick={() => window.location.reload()}
                className="flex-1 bg-gradient-to-r from-blue-500 to-indigo-500 hover:from-blue-600 hover:to-indigo-600 text-white shadow-lg shadow-blue-500/25"
              >
                <RefreshCw className="w-4 h-4 mr-2" />
                다시 시도
              </Button>
              <Button
                variant="outline"
                onClick={() => (window.location.href = '/')}
                className="flex-1 border-slate-200 hover:bg-slate-50"
              >
                <Home className="w-4 h-4 mr-2" />
                홈으로 이동
              </Button>
            </div>
          </div>
        </div>

        {/* Footer */}
        <p className="text-center text-xs text-slate-400 mt-4">
          문제가 지속되면 관리자에게 문의해 주세요.
        </p>
      </div>
    </div>
  );
};

export default RouteErrorBoundary;
